import { RECEIVED_KIPLINGER_REGISTRATION_INFO } from './KiplingerRegistrationActions';

export const kiplingerRegistrationInitialState = {};

export const kiplingerRegistrationReducer = (
  state = kiplingerRegistrationInitialState,
  action
) => {
  if (action.type === RECEIVED_KIPLINGER_REGISTRATION_INFO) {
    const { registrationURL } = action.payload;

    if (registrationURL) {
      return {
        kiplingerRegistrationUrl: registrationURL
      };
    }
  }
  return state;
};
